import { z } from 'zod'

import { jsonResponsiveImageSchema } from '@/types/jsonResponsiveImage.type'

const languageSchema = z.object({
	url: z.string(),
	label: z.string(),
	active: z.boolean(),
})

const navigationSchema = z.object({
	url: z.string(),
	label: z.string(),
})

const navigationEntrySchema = z.object({
	label: z.string(),
	items: z.array(navigationSchema),
})

const footerLinksSchema = z.object({
	languages: z.array(languageSchema),
	navigation: z.array(navigationEntrySchema),
})

const translationsSchema = z.record(z.string())

export const appConfigSchema = z.object({
	locationFilterDisabled: z.boolean().nullish(),
	rootUri: z.string(),
	translations: translationsSchema,
	theme: z.string(),
	inBackend: z.boolean().nullish(),
	enableServices: z.boolean(),
	heroTitle: z.string().nullish(),
	image: jsonResponsiveImageSchema,
	optirezCheckoutUrl: z.string(),
	successPageUrl: z.string(),
	footerLinks: footerLinksSchema,
	language: z.enum(['de', 'en', 'fr', 'it', 'da', 'dk']),
	disableBookingHotlineDisplay: z.boolean(),
	legalTextUrls: z.object({
		hotelConditionUrl: z.string(),
		parkingConditionUrl: z.string(),
		privacyPolicyUrl: z.string(),
	}),
	newsLetterIdentifier: z.string(),
	newsLetterListName: z.string(),
	newsLetterTextName: z.string(),
	reservationMail: z.string(),
})

export type AppConfigProps = z.infer<typeof appConfigSchema>
